import {
  AORTA_INTERPRETATION,
  DISTAL_AORTA,
  LONGITUDINAL_AORTA,
  MID_AORTA,
  PROXIMAL_AORTA,
} from "../groups/aorta";
import { option, text, type UsWorksheetDefinition } from "../us-fields";

export const US_AORTA: UsWorksheetDefinition = {
  examType: "us_aorta",
  version: 1,
  indications: [
    option("abdominal_pain", "Abdominal pain"),
    option("back_pain", "Back pain"),
    option("hypotension", "Hypotension"),
    option("syncope", "Syncope"),
    option("flank_pain", "Flank pain"),
    option("pulsatile_abdominal_mass", "Pulsatile abdominal mass"),
  ],
  otherIndication: true,
  sections: [
    {
      id: "aorta_findings",
      label: "Findings",
      role: "findings",
      technicallyLimited: true,
      fields: [
        PROXIMAL_AORTA,
        MID_AORTA,
        DISTAL_AORTA,
        LONGITUDINAL_AORTA,
        text("aorta.other_findings", "Other"),
      ],
    },
    {
      id: "aorta_interpretation",
      label: "Interpretation",
      role: "impression",
      fields: [AORTA_INTERPRETATION],
    },
  ],
  normalImpressions: [{ sectionId: "aorta_interpretation", value: "no_aaa" }],
  billing: {
    codes: [
      {
        cpt: "76775",
        label: "Ultrasound, abdominal aorta, limited",
        preTick: true,
      },
      {
        cpt: "76706",
        label: "Ultrasound, screening for abdominal aortic aneurysm",
      },
    ],
  },
};
